// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1Ouw4","header":"PatientBlock_header__3zIZj","label":"PatientBlock_label__3BImH","option":"PatientBlock_option__3-LUi"};